import Dashboard from '../containers/dashboard'
import PaymentsWithAlertsManagement from '../containers/payments-with-alerts-management'

const PaymentsWithAlerts = () => {
  return (
    <Dashboard>
      <PaymentsWithAlertsManagement />
    </Dashboard>
  )
}

export default PaymentsWithAlerts
